import { useState } from "react";
import { ArrowRight, Loader2, Check } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function UpgradeDialog({ plan }) {
  const { user, startCheckout, openAuth } = useAuth();
  const [busy, setBusy] = useState(false);
  const slug = plan.tier.toLowerCase().replace(/[^a-z0-9]+/g, "-");
  const owned = user && plan.planKey && user.plan_key === plan.planKey;

  const go = async () => {
    setBusy(true);
    try {
      await startCheckout(plan.planKey);
    } catch (e) {
      toast.error(e.message || "Could not start checkout");
      setBusy(false);
    }
  };

  const onClick = () => {
    if (!user) {
      toast.message("Sign in to continue to checkout");
      openAuth("login", go);
      return;
    }
    go();
  };

  if (owned) {
    return (
      <div
        data-testid={`owned-${slug}`}
        className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-full border border-sage/40 bg-sage/10 px-4 py-2.5 text-sm font-semibold text-sage"
      >
        <Check className="h-4 w-4" /> Owned
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={busy}
      data-testid={`buy-upgrade-${slug}`}
      className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-full bg-primary px-4 py-2.5 text-sm font-semibold text-primary-foreground transition-transform hover:scale-[1.02] disabled:opacity-60"
    >
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
      Buy / Upgrade <ArrowRight className="h-4 w-4" />
    </button>
  );
}
